import { render } from "./PublicMakePledge.vue?vue&type=template&id=9c05bb22&scoped=true"
import script from "./PublicMakePledge.vue?vue&type=script&lang=js"
export * from "./PublicMakePledge.vue?vue&type=script&lang=js"

import "./PublicMakePledge.vue?vue&type=style&index=0&id=9c05bb22&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c05bb22"]])

export default __exports__